import { create } from 'zustand'
import * as api from '@/lib/api'

export const useCustomer = create(() => {
  return {
    status: 0,
  }
})

export function fetchCustomer() {
  api
    .getCustomer()
    .then((customer) => {
      useCustomer.setState({ status: customer.status_code })
    })
    .catch(() => {
      useCustomer.setState({ status: 0 })
    })
}
